// Il modulo unico per il consenso cookie/ads: il banner e ogni invio di dati lo importano da qui.
declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

export const STORAGE_KEY = "cookie_consent";
export const REOPEN_KEY = "cookie_consent_reopen";

const CONSENT_COUNTRIES = [
  "AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE", "GR",
  "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT", "RO", "SK",
  "SI", "ES", "SE", "IS", "LI", "NO", "GB", "CH", "CA",
];

export async function isConsentRequiredRegion(): Promise<boolean> {
  try {
    const res = await fetch("/cdn-cgi/trace", { signal: AbortSignal.timeout(2000) });
    if (!res.ok) return true;
    const country = (await res.text()).match(/^loc=([A-Z0-9]{2})$/m)?.[1];
    if (!country || country === "XX" || country === "T1") return true;
    return CONSENT_COUNTRIES.includes(country);
  } catch {
    return true;
  }
}

// Verdetto di consenso per ogni invio di dati: scelta salvata, oppure nessun consenso
// se c'è una riapertura in sospeso, oppure nessun consenso richiesto nella regione.
export async function hasAdConsent(): Promise<boolean> {
  const choice = localStorage.getItem(STORAGE_KEY);
  if (choice) return choice === "granted";
  if (sessionStorage.getItem(REOPEN_KEY)) return false;
  return !(await isConsentRequiredRegion());
}

export function updateConsent(decision: "granted" | "denied") {
  window.gtag?.("consent", "update", {
    ad_storage: decision,
    ad_user_data: decision,
    ad_personalization: decision,
    analytics_storage: decision,
  });
}

// Riapre il banner da qualunque pagina (link "Preferenze cookie" nel footer).
export function reopenCookieBanner() {
  localStorage.removeItem(STORAGE_KEY);
  sessionStorage.setItem(REOPEN_KEY, "1");
  location.reload();
}
